export default function mockSubscribers(update = false) {
  return update
    ? {
        notificationSubscribers: [{ email: 'updated.foo.bar@example.com' }]
      }
    : {
        notificationSubscribers: [{ email: 'foo.bar@example.com' }]
      };
}
